import api from './api';

export const updateAdvertisement = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = data.fileBase64 || '';
    let pictureBase64 = data.pictureBase64 || '';
    
    // Mevcut resim/dosya bilgilerini korumak için flag'ler
    const keepExistingPicture = !data.picture && data.existingPictureUrl;
    const keepExistingFile = !data.file && data.existingFileUrl;

    // Convert picture to base64 if it's a File object
    if (data.picture && data.picture instanceof File) {
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture); // Use readAsDataURL to preserve MIME type
        reader.onload = () => {
          // This includes the MIME type prefix (e.g., data:image/jpeg;base64,)
          const dataUrl = reader.result;
          console.log('Resim base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.picture.size / 1024).toFixed(2)} KB`,
            base64Size: `${(dataUrl.length * 0.75 / 1024).toFixed(2)} KB`,
            preview: `${dataUrl.substring(0, 50)}...`,
            type: data.picture.type
          });
          resolve(dataUrl);
        };
        reader.onerror = error => reject(error);
      });
    }

    // Convert file to base64 if it's a File object
    if (data.file && data.file instanceof File) {
      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file); // Use readAsDataURL to preserve MIME type
        reader.onload = () => {
          // This includes the MIME type prefix (e.g., data:application/pdf;base64,)
          const dataUrl = reader.result;
          console.log('Dosya base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.file.size / 1024).toFixed(2)} KB`,
            base64Size: `${(dataUrl.length * 0.75 / 1024).toFixed(2)} KB`,
            preview: `${dataUrl.substring(0, 50)}...`,
            type: data.file.type
          });
          resolve(dataUrl);
        };
        reader.onerror = error => reject(error);
      });
    }

    const payload = {
      guid: data.guid,
      date: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      pictureBase64: keepExistingPicture ? null : pictureBase64,
      fileBase64: keepExistingFile ? null : fileBase64,
      keepExistingPicture: keepExistingPicture,
      keepExistingFile: keepExistingFile
    };

    console.log('Güncellenecek ilan verisi:', {
      guid: payload.guid,
      date: payload.date,
      header: payload.header,
      detail: payload.detail,
      pictureBase64: pictureBase64 ? `${pictureBase64.substring(0, 50)}...` : null,
      fileBase64: fileBase64 ? `${fileBase64.substring(0, 50)}...` : null,
      keepExistingPicture: keepExistingPicture,
      keepExistingFile: keepExistingFile
    });

    const response = await api.post('/api/Adversitement/UpdateAdvertisement', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    // API true veya "true" dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true' || response.data?.isSuccess) {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error updating advertisement:', error);
    throw error;
  }
};

export const getAdvertisements = async (params) => {
  try {
    console.log('Sending request with params:', params);
    const token = localStorage.getItem('token');
    const response = await api.post('/api/Adversitement/GetActiveAdvertisements', params, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Raw API Response:', response);
    return response.data;
  } catch (error) {
    console.error('Error fetching advertisements:', error);
    throw error;
  }
};

export const deleteAdvertisement = async (guid) => {
  try {
    console.log('Sending request to delete advertisement with guid:', guid);
    const token = localStorage.getItem('token');
    const response = await api.post('/api/Adversitement/DeleteAdvertisement', 
      { guid },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    console.log('Raw API Response:', response);
    
    // API true veya "true" dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error deleting advertisement:', error);
    throw error;
  }
};

export const addAdvertisement = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let fileBase64 = '';
    let pictureBase64 = '';

    // Convert picture to base64 if it exists
    if (data.picture) {
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture); // MIME type'ı korumak için readAsDataURL kullan
        reader.onload = () => {
          const dataUrl = reader.result; // data:image/jpeg;base64,... formatında
          console.log('Resim base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.picture.size / 1024).toFixed(2)} KB`,
            base64Size: `${(dataUrl.length * 0.75 / 1024).toFixed(2)} KB`,
            preview: `${dataUrl.substring(0, 50)}...`,
            type: data.picture.type
          });
          resolve(dataUrl);
        };
        reader.onerror = error => reject(error);
      });
    }

    // Convert file to base64 if it exists
    if (data.file) {
      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file); // MIME type'ı korumak için readAsDataURL kullan
        reader.onload = () => {
          const dataUrl = reader.result; // data:application/pdf;base64,... formatında
          console.log('Dosya base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.file.size / 1024).toFixed(2)} KB`,
            base64Size: `${(dataUrl.length * 0.75 / 1024).toFixed(2)} KB`,
            preview: `${dataUrl.substring(0, 50)}...`,
            type: data.file.type
          });
          resolve(dataUrl);
        };
        reader.onerror = error => reject(error);
      });
    }

    const payload = {
      date: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      pictureBase64: pictureBase64,
      fileBase64: fileBase64,
      pictureUrl: data.picture?.name || '',
      fileUrl: data.file?.name || ''
    };

    console.log('Gönderilecek ilan verisi:', {
      date: payload.date,
      header: payload.header,
      detail: payload.detail,
      picture: pictureBase64 ? {
        name: data.picture.name,
        type: data.picture.type,
        size: `${(data.picture.size / 1024).toFixed(2)} KB`,
        base64Size: `${(pictureBase64.length * 0.75 / 1024).toFixed(2)} KB`
      } : null,
      file: fileBase64 ? {
        name: data.file.name,
        type: data.file.type,
        size: `${(data.file.size / 1024).toFixed(2)} KB`,
        base64Size: `${(fileBase64.length * 0.75 / 1024).toFixed(2)} KB`
      } : null
    });

    const response = await api.post('/api/Adversitement/AddAdvertisement', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    // API true veya "true" dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error adding advertisement:', error);
    throw error;
  }
};
